import api from './api';

export interface TimeSlot {
  id: number;
  enabled: boolean;
  start_time: string | null;
  end_time: string | null;
  DeviceId: number;
  created_at: string;
  updated_at: string;
}

export interface Device {
  id: number;
  name: string;
  nickname?: string;
  api_key: string;
  fw_version: string;
  mac_address: string;
  last_seen: string;
  status: 'active' | 'inactive';
  speaker: string;
  volume: number;
  created_at: string;
  updated_at: string;
  CustomerId: number;
  TimeSlot?: TimeSlot;
}

export const deviceService = {
  getMyDevices: async (): Promise<Device[]> => {
    const response = await api.get('/devices/my-devices');
    return response.data;
  },

  registerDevice: async (name: string, mac_address: string): Promise<Device> => {
    const response = await api.post('/devices/register', { name, mac_address });
    return response.data.device;
  },

  deleteDevice: async (deviceId: number): Promise<void> => {
    await api.delete(`/devices/${deviceId}`);
  },

  updateDeviceSpeaker: async (deviceId: number, speaker: string): Promise<Device> => {
    const response = await api.post(`/devices/${deviceId}/speaker`, { speaker });
    return response.data.device;
  },

  updateDeviceConfig: async (
    deviceId: number,
    config: {
      volume: number;
      spotify_device: string;
      time_slot: {
        enabled: boolean;
        start_time: string | null;
        end_time: string | null;
      };
      nickname: string;
    }
  ): Promise<Device> => {
    const response = await api.put(`/devices/${deviceId}/config`, config);
    return response.data;
  },
};
